import { defaultSearcherItems } from 'shared/searchers';
import { HeaderManifest } from './types';

const socialNetworkOptions = [
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'twitter', label: 'Twitter' },
  { value: 'x', label: 'X' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'linkedin', label: 'LinkedIn' },
];

export const manifest: HeaderManifest = {
  fields: [
    { name: 'logoText', label: 'Logo (texto)', type: 'text', default: 'AGENCIA TURISMO' },
    { name: 'logoImageUrl', label: 'Logo (imagen, opcional)', type: 'text', default: '' },
    {
      name: 'iconColor',
      label: 'Color de íconos de buscadores',
      type: 'color',
      default: '#54a5e8',
    },
    { name: 'contactColor', label: 'Color de contacto y redes', type: 'color', default: '#54a5e8' },
    { name: 'brandColor', label: 'Color principal', type: 'color', default: '#54a5e8' },
    { name: 'showPhone', label: 'Mostrar teléfono', type: 'boolean', default: true },
    { name: 'phone', label: 'Teléfono', type: 'text', default: '+54 9 11 1234 5678' },
    { name: 'showEmail', label: 'Mostrar correo', type: 'boolean', default: true },
    {
      name: 'email',
      label: 'Correo electrónico',
      type: 'text',
      default: 'info@agenciaturismo.com',
    },
    { name: 'showWhatsapp', label: 'Mostrar WhatsApp', type: 'boolean', default: true },
    { name: 'whatsapp', label: 'Número de WhatsApp', type: 'text', default: '5491112345678' },
    {
      name: 'socialLinks',
      label: 'Redes sociales',
      type: 'array',
      itemShape: [
        {
          name: 'network',
          label: 'Red',
          type: 'select',
          options: socialNetworkOptions,
          default: 'facebook',
        },
        { name: 'url', label: 'URL', type: 'text', default: '' },
        { name: 'show', label: 'Mostrar', type: 'boolean', default: true },
      ],
      default: [
        { network: 'facebook', url: '', show: true },
        { network: 'instagram', url: '', show: true },
      ],
    },
    {
      name: 'menuItems',
      label: 'Menú principal',
      type: 'array',
      itemShape: [
        { name: 'id', label: 'Id', type: 'text', default: '' },
        { name: 'label', label: 'Texto', type: 'text', default: '' },
      ],
      default: [],
    },
    {
      name: 'searcherItems',
      label: 'Buscadores (barra superior)',
      type: 'array',
      itemShape: [
        { name: 'id', label: 'Id', type: 'text', default: '' },
        { name: 'url', label: 'URL', type: 'text', default: '' },
        { name: 'show', label: 'Mostrar', type: 'boolean', default: true },
      ],
      default: defaultSearcherItems(),
    },
    { name: 'activeSearcherId', label: 'Buscador activo', type: 'text', default: 'paquetes' },
    { name: 'fullBleed', label: 'Imagen hasta el borde superior', type: 'boolean', default: false },
  ],
};
